import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MasterService } from 'src/app/services/master.service';
import { AuthenticationService } from '../../../../services/authentication.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { VGroups } from '../../../../model/structures';
import {
  faShieldHalved,
  faPen,
  faEnvelope,
  faPhone,
  faShield,
  faBoxArchive,
  faUser,
  faLayerGroup
} from '@fortawesome/free-solid-svg-icons';
import { ModuleAddDialogComponent } from '../add_module_dialog/add_module_dialog.component';
import { ModuleEditDialogComponent } from '../edit_module_dialog/edit_module_dialog.component';
import { Module } from 'src/app/interfaces/module';

@Component({
  selector: 'modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.css']
})
export class AddModule implements OnInit {
public faModule = faUser;
  public faLayerGroup = faLayerGroup;
  public faShieldHalved = faShieldHalved;
  public faPen = faPen;
  public faEnvelope = faEnvelope;
  public faPhone = faPhone;
  public faShield = faShield;
  public faBoxArchive = faBoxArchive;
  public flEdit = 0;
  public struct_data: any;
  @Input() ID: number = 0;
  displayedColumns: string[] = ['ID', 'ShortTitle', 'Description', 'CommandLine', 'InputParametrs', 'SecurityLevel', 'ArchiveSign', 'Edit'];
  dataSourceModules: any;
  modules_data: any;
  selected_module: any;

  //
  @ViewChild(MatPaginator) paginator !: MatPaginator;
  @ViewChild(MatSort) sort !: MatSort;

  constructor(
    private service: MasterService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private storageService: AuthenticationService,
    private router: Router,
    
  ) { }
  //------------------------------------------------------------------------------
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }

  ngOnInit(): void {
    this.GetModulesTable();
  }
  //------------------------------------------------------------------------------
  openEditModuleDialog(module: Module) {
      const dialogConfig = new MatDialogConfig();
  
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data = {
        module: module,
      };
  
      const dialogRef = this.dialog.open(
        ModuleEditDialogComponent,
        dialogConfig
      );
  
      dialogRef.afterClosed().subscribe((data) => {
        this.refresh();
      });
    }

  openAddModuleDialog() {
      const dialogConfig = new MatDialogConfig();
  
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
  
      dialogConfig.data = {};
  
      const dialogRef = this.dialog.open(ModuleAddDialogComponent, dialogConfig);
  
      dialogRef.afterClosed().subscribe((data) => {
        this.refresh();
      });
    }


  GetModulesTable() {
    this.service.Get_modules().subscribe((result: any) => {
      if (result.data != null) {
        this.storageService.saveToken(result.jwt);
        this.modules_data = result.data;
        if (!this.show_archieved) {
      
          this.modules_data = this.modules_data.filter((module: { ArchiveSign: boolean; }) => module.ArchiveSign !== true);
        }
        this.dataSourceModules = new MatTableDataSource<VGroups>(this.modules_data);
        this.dataSourceModules.paginator = this.paginator;
        this.dataSourceModules.sort = this.sort;
      }
      else {
        this.router.navigate(['login']);
      }

    });
  }
  //------------------------------------------------------------------------------
  Filterchange(event: Event) {
    const filvalue = (event.target as HTMLInputElement).value;
    this.dataSourceModules.filter = filvalue;
  }
  //------------------------------------------------------------------------------
  getrow(row: any) {
    this.selected_module = row;
    //console.log(row);
  }
  //---------------------------------------------------------------------------
  public refresh() {
    console.log('refresh modules');
    
    this.GetModulesTable();
  }
  //---------------------------------------------------------------------------
  public ChangeArchivated(module: Module) {
    console.log('change archivated');
    
    this.service.Update_module(module).subscribe((result: any) => {
     this.refresh();

    });
  }
  //------------------------------------------------------------------------------
  ngOnChanges() {
    this.GetModulesTable();
    console.log('ngOnChanges modules');
  }
  show_archieved(){
    
  }
}
